import React from "react";
import "./Auth.scss";

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authContainer">
      <div className="auth_box">
        <figure className="auth_logo">
          <img src="/static/images/logo.png" alt="MEITECH.X Logo" />
        </figure>
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
